import React, { useState, useContext, createContext } from 'react'

const MatriculaModalPaginationContext = createContext({})

export function MatriculaModalPaginationProvider({ children }) {
  const [currentPage, setCurrentPage] = useState(0)
  const [hasPageChanged, setHasPageChanged] = useState(false)

  function handleMatriculaModalPageChange(page) {
    setCurrentPage(page)
    setHasPageChanged(true)
  }

  function onMatriculaModalClose() {
    setCurrentPage(0)
    setHasPageChanged(false)
  }

  return (
    <MatriculaModalPaginationContext.Provider
      value={{ handleMatriculaModalPageChange, onMatriculaModalClose, currentPage, hasPageChanged }}
    >
      {children}
    </MatriculaModalPaginationContext.Provider>
  )
}

export function useMatriculaModalPagination() {
  const context = useContext(MatriculaModalPaginationContext)

  return context
}
